module.exports = __webpack_public_path__ + "img/max-file-content-image-deny.4cdf37ef.svg";